import React, { useEffect, useRef } from "react";
import cn from 'classnames';
import styles from './TableCheckBox.module.css';

type TableCheckBoxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  indeterminate?: boolean;
  className?: string;
};

const TableCheckBox: React.FC<TableCheckBoxProps> = ({
  indeterminate,
  className,
  ...rest
}) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = !!indeterminate && !rest.checked;
    }
  }, [indeterminate, rest.checked]);

  return (
  <div className={cn(styles.checkboxWrapper)}>
    <input type="checkbox" ref={ref} {...rest} />
  </div>
  );
};

export default TableCheckBox;
